// Vendors
import React, { useState } from 'react'

// Components
import { FieldRadioButton } from 'components/FieldRadioButton'
import { FormFieldEditerFieldType } from 'components/FormFieldEditerFieldType'
import { FormFieldEditerFieldPreview } from 'components/FormFieldEditerFieldPreview'
import {
  FormFieldEditer,
  FormFieldEditerProps,
} from 'components/FormFieldEditer'
import {
  FormFieldEditerOptions,
  OptionsType,
} from 'components/FormFieldEditerOptions'

// Styles

// Interfaces
export type FormFieldEditerSingleChoiceProps = {
  index: number
  id: string
}

export const FormFieldEditerSingleChoice = (
  props: FormFieldEditerProps
): JSX.Element => {
  /*
  |-----------------------------------------------------------------------------
  | Constants
  |-----------------------------------------------------------------------------
  |
  |
  */

  /*
  |-----------------------------------------------------------------------------
  | States
  |-----------------------------------------------------------------------------
  |
  |
  */

  const [fieldName, setFieldName] = useState(props.question.label)
  const [options, setOptions] = useState<OptionsType[]>(props.question.options)

  /*
  |-----------------------------------------------------------------------------
  | Functions
  |-----------------------------------------------------------------------------
  |
  |
  */

  /*
  |-----------------------------------------------------------------------------
  | Renders
  |-----------------------------------------------------------------------------
  |
  |
  */
  return (
    <FormFieldEditer {...props}>
      <FormFieldEditerFieldType
        index={props.index}
        handleQuestion={props.handleQuestion}
        fieldTypeLabel="SELEÇÃO ÚNICA"
        fieldName={{ get: fieldName, set: setFieldName }}
      >
        <FormFieldEditerOptions
          options={options}
          setOptions={setOptions}
          index={props.index}
          handleQuestion={props.handleQuestion}
        />
      </FormFieldEditerFieldType>

      <FormFieldEditerFieldPreview>
        <FieldRadioButton
          options={options}
          label={fieldName !== '' ? fieldName : 'Nome do campo'}
        />
      </FormFieldEditerFieldPreview>
    </FormFieldEditer>
  )
}
